import "select2";
import {
  getReportTrendLabel,
  modMap,
  modMapColorBorder
} from './helper'

jQuery(function ($) {
  if ($("#gsod-world-map").length > 0) {
    const baseUrl = $("#base-url").data("base-url");

    let mapData;
    let subAttrMapData;
    let mapType = "AV-RG";
    let subAttrMapType = null;
    let dataset;
    let selectedRegions = []; // Initialize as empty array

    // Function to hide the views election filter
    function hideViewsElectionFilter() {
      // Hide the views filter form elements
      $('.view-id-elections .form-item-field-year-value').hide();
      $('.view-id-elections .form--inline .form-actions').hide();

      // Add a heading above the table for better context
      $('.view-id-elections table').addClass('w-full border-collapse');
    }

    /**
     * Updates the views election filter with the selected year value.
     *
     * @param {string} yearValue - The year value to set in the filter
     */
    function updateViewsElectionFilter(yearValue) {
      // Get the views filter input for year
      const viewsYearFilter = $('.view-id-elections .form-item-field-year-value input');

      if (viewsYearFilter.length) {
        // Set the value in the filter
        viewsYearFilter.val(yearValue);

        // Find and click the Apply button to refresh the view
        const applyButton = $('.view-id-elections .form--inline .form-actions .form-submit[value="Apply"]');
        if (applyButton.length) {
          applyButton.click();
        } else {
          // Fallback if the button doesn't have the expected value attribute
          $('.view-id-elections .form--inline .form-actions .form-submit').first().click();
        }

        // Update the heading to show which year is being displayed
        $('.elections-table-container h2').text('Elections List - ' + yearValue);
      }
    }

    // Hide the views filter initially
    hideViewsElectionFilter();
    let colors = {
      StrongPositive: "#00AB63",
      Positive: "#48CE96",
      Neutral: "#7D8A98",
      Negative: "#F56363",
      StrongNegative: "#D81B1B",
      Authoritarian: "#EAA146",
      Democracy: "#97DDCC",
      Hybrid: "#A18CBF",
      Value: "#2260DA",
      None: "#F0F0F0",
      Election: "#3B82F6", // Regular election color
      UpcomingElection: "#E08C47", // Orange for upcoming elections
      PastElection: "#644C96", // Purple for past elections
      DisruptedElection: "#727F8C", // Gray for disrupted elections
      MultipleElection: "#B8A4DF", // Light purple for multiple elections
    };

    let dataCategory = "MT";
    let dataSubCategory = "all_attributes";

    const apiUrl = baseUrl + "api/gsod-indices-data";
    const electionsApiUrl = baseUrl + "api/gsod-elections";

    // Listen for radio button click events
    const eventEaRadio = $("#event-ea");
    const annualAvRadio = $("#annual-av");
    const electionsRadio = $("#elections");
    const monthlyTrendDiv = $(".map-types-monthly-trend");
    const annualValuesDiv = $(".map-types-annual-values");
    const eventAssessmentsSelect = $("#worldmap-month");
    const annualValuesSelect = $("#worldmap-year");
    const electionsYearSelect = $("#elections-year");


    eventAssessmentsSelect.prop("disabled", true);
    // Add change event handlers
    eventEaRadio.on("change", function () {
      if (eventEaRadio.is(":checked")) {
        monthlyTrendDiv.show();
        annualValuesDiv.hide();
        eventAssessmentsSelect.css("opacity", "1");
        eventAssessmentsSelect.prop("disabled", false);
        annualValuesSelect.css("opacity", "0.6");
        annualValuesSelect.prop("disabled", true);
        electionsYearSelect.css("opacity", "0.6");
        electionsYearSelect.prop("disabled", true);
        const representationRadioButton =
          document.getElementById("all-attributes");
        representationRadioButton.checked = true;
        mapType = "MT-AA";
        
        // Get the value of #worldmap-month
        const val = eventAssessmentsSelect.val();
        
        // First fetch the data, then update the map
        // Call the callAjax function with the URL
        const url =
          apiUrl + "?year=" + val.split("-")[0] + "&month=" + val.split("-")[1];
        
        // Clear mapData to remove leftover data from other map types
        mapData = {};
        
        // Call Ajax and update the map after data is loaded
        $("#map-loading-blocker").fadeIn();
        $.ajax({
          url: url,
          method: "GET",
          timeout: 0,
          headers: {
            "Content-Type": "application/json",
          },
          error: function (error) {
            $("#map-loading-blocker").fadeOut();
          },
          success: function(response) {
            mapData = response;
            
            // Now that we have the data, update the map
            switchMapData(mapType);
            switchMapLegend();
            
            $("#map-loading-blocker").fadeOut();
          }
        });
        
        // Hide the elections table when not in elections mode
        $('.elections-table-container').hide();
      }
    });


    annualAvRadio.on("change", function () {
      if (annualAvRadio.is(":checked")) {
        monthlyTrendDiv.hide();
        annualValuesDiv.show();

        // Enable annual values select
        annualValuesSelect.css("opacity", "1");
        annualValuesSelect.prop("disabled", false);

        // Disable other selects
        eventAssessmentsSelect.css("opacity", "0.6");
        eventAssessmentsSelect.prop("disabled", true);
        electionsYearSelect.css("opacity", "0.6");
        electionsYearSelect.prop("disabled", true);

        const representationRadioButton = document.getElementById(
          "av-representative-government"
        );
        representationRadioButton.checked = true;
        mapType = "AV-RG";

        // Get the selected year value
        const val = annualValuesSelect.val();
        const url = apiUrl + "?year=" + val.split("-")[0];

        // Clear mapData to remove leftover monthly data
        mapData = {};

        // Fetch the correct annual values
        callAjax(url);

        // Hide the elections table when not in elections mode
        $('.elections-table-container').hide();
      }
    });

    electionsRadio.on("change", function () {
      if (electionsRadio.is(":checked")) {
        monthlyTrendDiv.hide();
        annualValuesDiv.hide();
        electionsYearSelect.css("opacity", "1");
        electionsYearSelect.prop("disabled", false);
        annualValuesSelect.css("opacity", "0.6");
        annualValuesSelect.prop("disabled", true);
        eventAssessmentsSelect.css("opacity", "0.6");
        eventAssessmentsSelect.prop("disabled", true);

        mapType = "EL"; // Elections map type

        // Get the selected year value
        const val = electionsYearSelect.val();
        const url = val ? electionsApiUrl + "?year=" + val : electionsApiUrl;

        // Clear mapData to remove leftover data from other map types
        mapData = {};

        // Fetch the elections data
        callAjax(url);

        // Switch to elections legend
        switchMapLegend();

        // Show the elections table
        $('.elections-table-container').show();

        // Update the views filter with the selected year
        updateViewsElectionFilter(val);
      }
    });


    function callAjax(url, isSubAttrMapType = false) {
      // API settings
      $("#map-loading-blocker").fadeIn();

      const settings = {
        url: url,
        method: "GET",
        timeout: 0,
        headers: {
          "Content-Type": "application/json",
        },
        error: function (error) {
          $("#map-loading-blocker").fadeOut();
        },
      };

      // Call API to get chart data
      $.ajax(settings).done(function (response) {
        if (isSubAttrMapType) {
          subAttrMapData = response;
        } else {
          mapData = response;
        }

        switchMapData(mapType, subAttrMapType);
        switchMapLegend();

        $("#map-loading-blocker").fadeOut();
      });
    }

    const defaultMonth = $("#worldmap-month").val();

    // Since Elections radio is checked by default, initialize with Elections data
    if (electionsRadio.is(":checked")) {
      // Hide other map type options
      monthlyTrendDiv.hide();
      annualValuesDiv.hide();

      // Get the selected value from the dropdown (set by the template)
      const selectedYear = electionsYearSelect.val();

      // Call the elections API with the selected year as filter
      const url = selectedYear ? electionsApiUrl + "?year=" + selectedYear : electionsApiUrl;
      callAjax(url);
      mapType = "EL";

      // Make sure other selects are disabled
      eventAssessmentsSelect.css("opacity", "0.6");
      eventAssessmentsSelect.prop("disabled", true);
      annualValuesSelect.css("opacity", "0.6");
      annualValuesSelect.prop("disabled", true);

      // Make sure elections year select is enabled
      electionsYearSelect.css("opacity", "1");
      electionsYearSelect.prop("disabled", false);

      // Switch to elections legend
      switchMapLegend();

      // Show the elections table
      $('.elections-table-container').show();

      // Update the views filter with the selected year
      updateViewsElectionFilter(selectedYear);
    } else {
      // Hide the elections table for other map types
      $('.elections-table-container').hide();
      callAjax(apiUrl + "?year=2022");
    }

    $("#worldmap-month").on("change", function () {
      const val = $(this).val();
      const url =
        apiUrl + "?year=" + val.split("-")[0] + "&month=" + val.split("-")[1];
      callAjax(url);
    });

    $("#worldmap-year").on("change", function () {
      const val = $(this).val();

      if (mapType === "AV-subAttr") {
        handleSubattributeMapType(subAttrMapType);
      } else {
        const url = apiUrl + "?year=" + val.split("-")[0];
        callAjax(url);
      }
    });

    $("#elections-year").on("change", function () {
      const val = $(this).val();
      // If a year is selected, add it as a query parameter, otherwise call the API without a year filter
      const url = val ? electionsApiUrl + "?year=" + val : electionsApiUrl;
      callAjax(url);

      // Update the views filter with the same year value
      updateViewsElectionFilter(val);
    });

    var theMap = $("#gsod-world-map");

    theMap.vectorMap({
      map: "world_mill",
      backgroundColor: "white",
      panOnDrag: true,
      zoomAnimate: true,
      zoomOnScroll: false,
      // zoomMax: 30,
      // zoomStep: 1.6,
      markerStyle: {
        initial: {
          // fill: 'transparent',
          stroke: "#222222",
          "stroke-width": 3,
          r: 6,
        },
      },
      focusOn: {
        x: 0.5,
        y: 0.5,
        scale: 1,
      },
      regionStyle: {
        initial: {
          fill: "#F0F0F0",
          "fill-opacity": 1,
          stroke: "none",
          "stroke-width": 0,
          "stroke-opacity": 1,
        },
      },
      onRegionClick: function (event, code) {
        if (mapType.startsWith("MT-")) {
          const foundCountry =
            dataset && dataset.find((item) => item.country === code);
          if (foundCountry) {
            window.open(foundCountry.permalink);
          } else {
            // console.error("No country data found");
          }
        } else if (mapType === "EL") {
          const foundCountry =
            dataset && dataset.find((item) => item.country === code);
          if (foundCountry && foundCountry.nid) {
            // Open the node page for this election
            window.open(baseUrl + 'node/' + foundCountry.nid);
          } else {
            // No election found for this country
          }
        }
      },
      onRegionOver: function (e, code) {
        e.preventDefault();

        // Check if selectedRegions exists and contains the code
        if (!selectedRegions || !Array.isArray(selectedRegions) || selectedRegions.indexOf(code) < 0) {
          return;
        }

        $("body").append(getToolTip(code));

        var tip = $("body .map-tool-tip");

        $(this).on("mousemove", function (e) {
          var top = window.pageYOffset || document.documentElement.scrollTop;

          tip.css("top", e.pageY - 15 - top + "px");
          tip.css("left", e.pageX + "px");
        });
      },
      onRegionOut: function () {
        $("body .map-tool-tip").remove();
      },
      onRegionTipShow: function (e) {
        e.preventDefault();
        return false;
      },
      onViewportChange: function (e, scale) {
        // console.log('onViewportChange', e.target, 'scale', scale);
      },
    });
    // theMap.vectorMap END

    modMap(theMap);

    var myMap = theMap.vectorMap("get", "mapObject");

    myMap.clearSelectedRegions();

    function switchMapData(mapType, subAttrMapType = null) {
      // Check if we're switching to Elections and we don't have valid data
      if (mapType === "EL" && (!mapData || !Array.isArray(mapData) || mapData.length === 0)) {
        // Reload elections data
        const val = electionsYearSelect.val();
        const url = val ? electionsApiUrl + "?year=" + val : electionsApiUrl;
        callAjax(url);
        return;
      }

      switch (mapType) {
        case "MT-AA":
          monthlyTrends("all_attributes");
          break;
        case "MT-RG":
          monthlyTrends("representation_est");
          break;
        case "MT-FR":
          monthlyTrends("rights_est");
          break;
        case "MT-PE":
          monthlyTrends("participation_est");
          break;
        case "MT-IA":
          monthlyTrends("rule_law_est");
          break;

        case "AV-RG":
          annualValues("representation_est");
          break;
        case "AV-FR":
          annualValues("rights_est");
          break;
        case "AV-PE":
          annualValues("participation_est");
          break;
        case "AV-IA":
          annualValues("rule_law_est");
          break;
        case "AV-subAttr":
          annualValues(subAttrMapType, true);
          break;

        case "ART":
          allRegime();
          break;

        case "EL":
          displayElections();
          break;

        default:
          break;
      }

      modMapColorBorder(theMap);
    }

    // On map type changed
    $('input[name="map_type"]').on("change", function () {
      const val = $(this).val();
      const type = $(this).data("type");

      subAttrMapType = null;

      if (type === "AV-subAttr") {
        mapType = type;
        subAttrMapType = val;

        handleSubattributeMapType(val);
      } else {
        mapType = val;

        switchMapData(mapType);

        switchMapLegend();
      }
    });

    function handleSubattributeMapType(subAttrValue) {
      // Call the callAjax function with the URL
      const val = annualValuesSelect.val();
      const url =
        apiUrl + "?year=" + val.split("-")[0] + "&subAttr=" + subAttrValue;
      callAjax(url, true);
    }

    function monthlyTrends(type) {
      // Check if mapData and monthly_trends exist before accessing
      if (!mapData || !mapData["monthly_trends"]) {
        return;
      }
      
      const data = mapData["monthly_trends"][type];
      dataset = data;

      // Check if myMap is defined before using it
      if (typeof myMap !== 'undefined') {
        myMap.clearSelectedRegions();

        if (data !== undefined && Array.isArray(data)) {
          data.map((item, key) => {
            if (myMap.regions[item.country] !== undefined) {
              myMap.regions[item.country].element.config.style.selected.fill =
                colors[item.value];
              myMap.setSelectedRegions(item.country);
            }
          });

          selectedRegions = myMap.getSelectedRegions();
        }
      }
    }

    function annualValues(type, isSubAttrMapType = false) {
      const data = isSubAttrMapType
        ? subAttrMapData["annual_values"][type]
        : mapData["annual_values"][type];
      dataset = data;

      // Check if myMap is defined before using it
      if (typeof myMap !== 'undefined' && data) {
        myMap.clearSelectedRegions();

        data.map((item, key) => {
          const v = item.value;
          const opacity = Math.floor((v * 0.8 + 0.2) * 255).toString(16);
          const color = colors["Value"] + opacity;

          if (myMap.regions[item.country] !== undefined) {
            myMap.regions[item.country].element.config.style.selected.fill =
              color;
            // myMap.regions[item.country].element.config.style.selected.fill = colors[item.value];
            myMap.setSelectedRegions(item.country);
          }
        });

        selectedRegions = myMap.getSelectedRegions();
      }
    }

    function allRegime() {
      const data = mapData["annual_regime"];
      dataset = data;

      // Check if myMap is defined before using it
      if (typeof myMap !== 'undefined') {
        myMap.clearSelectedRegions();

        if (data !== undefined) {
          data.map((item, key) => {
            if (myMap.regions[item.country] !== undefined) {
              const color = colors[item.value];
              myMap.regions[item.country].element.config.style.selected.fill =
                color;
              // myMap.regions[item.country].element.config.style.selected.fill = colors[item.value];
              myMap.setSelectedRegions(item.country);
            } else {
              // Region not found
            }
          });

          selectedRegions = myMap.getSelectedRegions();
        }
      }
    }

    function displayElections() {
      // Check if mapData exists and is an array
      if (!mapData || !Array.isArray(mapData) || mapData.length === 0) {
        // No valid data, try to reload
        const val = electionsYearSelect.val();
        const url = val ? electionsApiUrl + "?year=" + val : electionsApiUrl;
        callAjax(url);
        return;
      }

      dataset = mapData;

      // Check if myMap is defined before using it
      if (typeof myMap !== 'undefined') {
        myMap.clearSelectedRegions();
        
        // First, group elections by country to identify countries with multiple elections
        const countriesWithElections = {};
        
        mapData.forEach(item => {
          if (!countriesWithElections[item.country]) {
            countriesWithElections[item.country] = [];
          }
          countriesWithElections[item.country].push(item);
        });
        
        // Process each country according to the precedence rules
        Object.keys(countriesWithElections).forEach(countryCode => {
          if (myMap.regions[countryCode] !== undefined) {
            const countryElections = countriesWithElections[countryCode];
            let color;
            
            // Apply precedence rules: Multiple > Disrupted > Upcoming/Past
            if (countryElections.length > 1) {
              // Multiple elections in this country (highest precedence)
              color = colors.MultipleElection;
            } else {
              // Single election - check if disrupted
              const election = countryElections[0];
              if (election.disrupted && election.disrupted !== "") {
                // Disrupted election (second precedence)
                // This handles both boolean true and string values like "Postponed"
                color = colors.DisruptedElection;
              } else if (election.upcoming === true) {
                // Upcoming election
                color = colors.UpcomingElection;
              } else {
                // Past election (default)
                color = colors.PastElection;
              }
            }
            
            // Apply the color to the country
            myMap.regions[countryCode].element.config.style.selected.fill = color;
            myMap.setSelectedRegions(countryCode);
          }
        });

        selectedRegions = myMap.getSelectedRegions();
      }
    }

    // We're no longer dynamically rebuilding the select options
    // This function is kept for compatibility but doesn't modify the select options
    function updateElectionYearSelect() {
      // Get the election year select element
      const electionsYearSelect = $('#elections-year');

      // Get the currently selected value
      const selectedValue = electionsYearSelect.val();

      // Update the views filter with the selected year
      if (selectedValue) {
        updateViewsElectionFilter(selectedValue);
      }
    }

    // Return tooltip HTML
    function getToolTip(code) {
      const data = getDataForTooltip(mapType, code);

      // If no data found, don't show a tooltip
      if (!data) {
        return '';
      }

      const isMTMaps = mapType.startsWith('MT-');
      const isElectionMap = mapType === 'EL';

      let tooltipContent;

      if (isElectionMap) {
        // Check if this country has multiple elections
        const hasMultipleElections = dataset.filter(item => item.country === code).length > 1;
        
        if (hasMultipleElections) {
          // For countries with multiple elections, show a special message
          tooltipContent = '<div class="country-name font-aileron text-sm font-bold border-b border-grey-dark px-2 pb-2">' +
            data.name +
            '</div><div class="font-aileron text-sm px-2 pt-2">' +
            'Multiple elections' +
            '</div>';
        } else {
          // For Elections map type with single election, show election details with the new data structure
          tooltipContent = '<div class="country-name font-aileron text-sm font-bold border-b border-grey-dark px-2 pb-2">' +
            data.name +
            '</div><div class="font-aileron text-sm px-2 pt-2">' +
            data.title +
            '</div><div class="font-aileron text-sm px-2">' +
            'Date: ' + (data.report_date || (data.month + ' ' + data.year)) +
            '</div>';
        }
      } else {
        // For other map types
        const value = isMTMaps ? getReportTrendLabel(data.value) : data.value;
        tooltipContent = '<div class="country-name font-aileron text-sm font-bold border-b border-grey-dark px-2 pb-2">' +
          data.name +
          '</div><div class="font-aileron text-lg px-2 pt-2">' +
          value +
          '</div>';
      }

      return (
        '<div class="map-tool-tip drop-shadow-tooltip bg-white text-center px-1 py-3">' +
        tooltipContent +
        '</div>'
      );
    }

    function getDataForTooltip(type, code) {
      let dataSet;

      switch (type) {
        case "MT-AA":
          dataSet = mapData["monthly_trends"]["all_attributes"];
          break;
        case "MT-RG":
          dataSet = mapData["monthly_trends"]["representation_est"];
          break;
        case "MT-FR":
          dataSet = mapData["monthly_trends"]["rights_est"];
          break;
        case "MT-PE":
          dataSet = mapData["monthly_trends"]["participation_est"];
          break;
        case "MT-IA":
          dataSet = mapData["monthly_trends"]["rule_law_est"];
          break;

        case "AV-RG":
          dataSet = mapData["annual_values"]["representation_est"];
          break;
        case "AV-FR":
          dataSet = mapData["annual_values"]["rights_est"];
          break;
        case "AV-PE":
          dataSet = mapData["annual_values"]["participation_est"];
          break;
        case "AV-IA":
          dataSet = mapData["annual_values"]["rule_law_est"];
          break;
        case "AV-subAttr":
          dataSet = subAttrMapData["annual_values"][subAttrMapType];
          break;

        case "ART":
          dataSet = mapData["regime_type"];
          break;

        case "EL":
          // For elections, mapData is directly the array
          dataSet = mapData;
          break;

        default:
          break;
      }

      if (dataSet === undefined) {
        return false;
      }

      const data = dataSet.find((item, key) => {
        if (item.country === code) {
          return item;
        }
      });

      return data;
    }

    function switchMapLegend() {
      $(".map-legend").addClass("hidden");

      if (mapType === "EL") {
        // Show Elections legend
        $("#map-legend-EL").removeClass("hidden");
      } else {
        // Show other legends
        $("#map-legend-" + mapType.substring(0, 2)).removeClass("hidden");
      }
    }
  }
});
